import { Spacer } from '@components/1-atoms/Miscellaneous';
import styled from '@emotion/native';
import React, { FC, useEffect, useState } from 'react';

//@ts-ignore
import ReactDOM from 'react-dom';

import Header from './commons/Header';

import setTheme from '@lib/theme';

const Container = styled.View`
    align-items: center;
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    overflow: auto;
    
    background-color: ${({ transparent }: any) => transparent ? 'transparent' : `rgba(255, 255, 255, 1)`};
    ${props => props?.bg && `
        background-color: ${props?.bg};
    `}

    // possible space for button at the bottom of the modal
    padding-bottom: 41px;

    top: 0;
    left: 0;
    
    // This prevent the modal size from disrupting when navigating using the drawer of type slide or back
    width: 100%;
    height: 100%;
`;

const Content = styled.View`
    background-color: transparent;
    overflow-y: scroll;

    justify-content: flex-start;
    align-items: center;
    flex-direction: column;
    flex: 1;
    
    align-items: center;
    margin: auto;
    width: ${({ theme }: any) => `${Math.min(500, theme.contentWidth)}px`};
`;

type Props = {
    children?: React.ReactNode;
    transparent?: boolean;
    bg?: string;
    visible: boolean;

    title?: any;
    closable?: boolean;
    onClose?: () => void;
};

const theme = setTheme('light');
export const Modal: FC<Props> = ({ children, visible, title, onClose, closable = true, transparent = false, ...props }) => {
    const [portalNode, setPortalNode] = useState<HTMLDialogElement | null>(null);

    useEffect(() => {
        const node = document.createElement('dialog');
        node.style.border = '0';
        node.style.maxWidth = 'none';
        node.style.maxHeight = 'none';
        node.style.boxSizing = 'border-box';
        node.style.width = '100vw';
        node.style.height = '100vh';
        document.body.appendChild(node);
        visible ? node.showModal() : node.close();
        setPortalNode(node);

        return () => {
            document.body.removeChild(node);
        };
    }, []);

    useEffect(() => {
        if (portalNode) {
            visible ? portalNode.showModal() : portalNode.close();
        }
    }, [visible]);

    if (!visible) return;
    if (!portalNode) return;

    return ReactDOM.createPortal(
        <Container transparent={transparent} visible={visible} {...props} style={{ zIndex: 2 }}>
            <Header title={title} closable={closable} onClose={onClose} />
            <Spacer h={1} />

            <Content>
                {children}
            </Content>
        </Container>,
        portalNode
    );

};

export default Modal;
